<template>
  <div class="bg" @click="$emit('close')">
    <img
      ref="smallest"
      :src="smallestSrc"
      class="hidden"
      v-on:load="onLoadSmall"
    />
    <div
      v-if="noteType !== null"
      class="box"
      :class="{ invisible: !visible }"
      :style="`margin-top: ${imageMarginTop}`"
    >
      <div class="p-4 flex justify-between items-start">
        <div>
          <h2>Note {{ noteId() }}</h2>
        </div>
        <div class="cursor-pointer" @click="$emit('close')">Close</div>
      </div>
      <div class="inner">
        <img
          v-if="src"
          :src="src"
          class="waveform-image"
          :style="
            noteType === 'vocals'
              ? `height: ${vocalsHeight}px`
              : `height: ${keyboardHeight}px`
          "
          v-on:load="onLoadLarge"
        />
        <div class="absolute w-full h-full">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="waveform-overlay"
            :class="{
              'waveform-overlay-vocals': noteType === 'vocals',
              'waveform-overlay-keyboard': noteType === 'keyboard'
            }"
            v-on:click.stop="playSound(index)"
          >
            <div class="id-label">
              {{ index === 0 ? "original" : recordingId(index) }}
            </div>
            <audio :ref="`audio-${index}`" controls class="hidden">
              <source :src="item" type="audio/mpeg" />
            </audio>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Popup",

  props: {
    noteType: {
      type: String,
      default: null
    },
    noteIndex: {
      type: Number,
      default: null
    }
  },

  data() {
    return {
      items: [],
      heights: [50, 100, 250, 500, 750, 1000, 1500, 2000],
      vocalsHeight: 1000,
      keyboardHeight: 500,
      smallestSrc: null,
      src: null,
      imageMarginTop: "0",
      visible: false
    };
  },

  created() {
    window.addEventListener("resize", this.onResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },

  mounted() {
    const count = this.noteType === "keyboard" ? 7 : 13;
    for (let i = 0; i < count; i++) {
      this.items.push(`/audio/${this.noteType}/v${i}/${this.noteIndex}.mp3`);
    }

    const fileNumStr = this.padStart(3, this.noteIndex);
    this.smallestSrc = `/images/popups/${this.noteType}/${fileNumStr}_${this.heights[0]}h.jpg`;

    this.imageMarginTop = this.calcBoxMarginTop();
  },

  methods: {
    onLoadSmall() {
      let imageHeight =
        this.noteType === "keyboard" ? this.keyboardHeight : this.vocalsHeight;

      if (window.devicePixelRatio) {
        imageHeight *= window.devicePixelRatio;
      }

      const fileNumStr = this.padStart(3, this.noteIndex);
      this.src = `/images/popups/${this.noteType}/${fileNumStr}_${imageHeight}h.jpg`;

      // this.srcset = ''
      // for (let i = 0; i < this.heights.length; i++) {
      //   const url = `/images/popups/${this.noteType}/${fileNumStr}_${this.heights[i]}h.jpg`
      //   this.srcset += `${url} ${widths[i]}w`
      //   if (i < this.heights.length - 1) {
      //     this.srcset += ', '
      //   }
      // }

      // this.sizes = ''
      // for (let i = 0; i < widths.length; i++) {
      //   const w = widths[i]
      //   if (i !== widths.oength - 1) {
      //     this.sizes += `(max-width: ${w}px) ${w}px, `
      //   } else {
      //     this.sizes += `${w}px`
      //   }
      // }
    },

    onLoadLarge() {
      this.visible = true;
    },

    padStart(digits, num) {
      let str = num.toString();
      if (str.length >= digits) {
        return str;
      }

      const toAdd = digits - str.length;
      for (let i = 0; i < toAdd; i++) {
        str = "0" + str;
      }

      return str;
    },

    noteId() {
      return this.noteType === "keyboard"
        ? this.noteIndex
        : this.noteIndex + 248;
    },

    recordingId(index) {
      let id;
      if (this.noteType === "keyboard") {
        id = this.noteIndex + 248 * (index - 1) + 1;
      } else {
        id = 6 * 248 + this.noteIndex + 50 * (index - 1) + 1;
      }
      id = this.padStart(4, id);
      return id;
    },

    onResize() {
      this.imageMarginTop = this.calcBoxMarginTop();
    },

    calcBoxMarginTop() {
      const h = this.noteType === "keyboard" ? 560 : 1060;
      if (window.innerHeight < h) {
        const diff = h - window.innerHeight;
        const margin = `calc(${diff}px + 6rem)`;
        return margin;
      } else {
        return "2rem";
      }
    },

    playSound(index) {
      this.$refs[`audio-${index}`][0].play();
    }
  }
};
</script>

<style scoped>
.bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

.box {
  width: auto;
  background: white;
  border: 1px solid #999999;
  margin-top: 2rem;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
}

.box .inner {
  position: relative;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

img.waveform-image {
  margin-left: 4rem;
  margin-right: 1rem;
}

.waveform-overlay {
  cursor: pointer;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: rgba(255, 255, 255, 0.25);
}

.waveform-overlay:hover {
  background-color: rgba(255, 255, 255, 0);
}

/* .waveform-overlay:hover .id-label {
  color: red;
} */

.waveform-overlay-vocals {
  height: calc(100% / 13);
}

.waveform-overlay-keyboard {
  height: calc(100% / 7);
}

.id-label {
  padding-left: 1rem;
  width: 4rem;
}
</style>
